/**
 * Agent Manual Task Dialog Component
 */

import { Play } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Button } from '@/components/ui/button'

interface AgentManualTaskDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  instructions: string
  onInstructionsChange: (instructions: string) => void
  selectedNodes: string[]
  onSelectedNodesChange: (nodes: string[]) => void
  onExecuteTask: () => void
}

export function AgentManualTaskDialog({
  open,
  onOpenChange,
  instructions,
  onInstructionsChange,
  selectedNodes,
  onSelectedNodesChange,
  onExecuteTask,
}: AgentManualTaskDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Execute Manual Task</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Task Instructions</label>
            <Textarea
              value={instructions}
              onChange={(e) => onInstructionsChange(e.target.value)}
              placeholder="Describe what you want the agent to do..."
              rows={3}
            />
          </div>

          <div>
            <label className="text-sm font-medium">
              Target Nodes (optional)
            </label>
            <Input
              placeholder="Enter node IDs separated by commas"
              value={selectedNodes.join(', ')}
              onChange={(e) =>
                onSelectedNodesChange(
                  e.target.value
                    .split(',')
                    .map((s) => s.trim())
                    .filter(Boolean)
                )
              }
            />
          </div>

          <Button onClick={onExecuteTask} className="w-full">
            <Play className="w-4 h-4 mr-2" />
            Execute Task
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
